import React from "react"
import {useSearchParams} from "react-router"

import {parseKlaraPeriod, TKlaraPeriod} from "./period"

const PERIOD_PARAM = "period"
const FROM_PARAM = "from"
const TO_PARAM = "to"

export function useKlaraPeriod(): [TKlaraPeriod, (next: TKlaraPeriod) => void] {
  const [params, setParams] = useSearchParams()

  const value = React.useMemo(() => parseKlaraPeriod(params), [params])

  const setValue = React.useCallback(
    (next: TKlaraPeriod) => {
      setParams(
        prev => {
          const search = new URLSearchParams(prev)
          if (next.kind === "custom") {
            search.delete(PERIOD_PARAM)
            search.set(FROM_PARAM, next.from)
            search.set(TO_PARAM, next.to)
          } else {
            search.delete(FROM_PARAM)
            search.delete(TO_PARAM)
            if (next.preset === "30d") {
              search.delete(PERIOD_PARAM)
            } else {
              search.set(PERIOD_PARAM, next.preset)
            }
          }
          return search
        },
        {replace: true}
      )
    },
    [setParams]
  )

  return [value, setValue]
}
